import { render, staticRenderFns } from "./Dict.vue?vue&type=template&id=39b9b35d&scoped=true&"
import script from "./Dict.vue?vue&type=script&lang=js&"
export * from "./Dict.vue?vue&type=script&lang=js&"
import style0 from "./Dict.vue?vue&type=style&index=0&id=39b9b35d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9b35d",
  null
  
)

export default component.exports